import WaterMarkLogo from "../assets/img/AaysLogo.png"
import favicon from "../assets/img/favicon.png";

const uiConfig = {
  

  // Favicon
  favicon: favicon,

  //title
  title: "Aays CV Vault",
};

export const applyUiConfig = () => {
  if (typeof document === "undefined") {
    return;
  }

  // Page title
  if (uiConfig.title) {
    document.title = uiConfig.title;
  }

  // Favicon
  if (uiConfig.favicon) {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = uiConfig.favicon;
  }
};

export default uiConfig;
